import { render } from "./Joy.vue?vue&type=template&id=01f31b6e&scoped=true"
import script from "./Joy.vue?vue&type=script&lang=js"
export * from "./Joy.vue?vue&type=script&lang=js"

import "./Joy.vue?vue&type=style&index=0&id=01f31b6e&scoped=true&lang=css"
import "./Joy.vue?vue&type=style&index=1&id=01f31b6e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01f31b6e"]])

export default __exports__